'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var parseUrl = require('url-parse');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var parseUrl__default = /*#__PURE__*/_interopDefaultLegacy(parseUrl);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var VALID_ENV_FILTERS = ["dev", "test", "prod"];
var VALID_ENV_STATUSES = ["alpha", "beta", "stable", "archived"];
function assert(value, msg) {
    if (!value)
        throw new Error(msg);
}
function assertValidStringArray(value, valueName) {
    if (valueName === void 0) { valueName = 'value'; }
    assert(value instanceof Array, valueName + " must be an array of strings");
    for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
        var name_1 = value_1[_i];
        assert(typeof name_1 === "string", "Each item in " + valueName + " must be a string");
    }
}
function parseValidUrl(value) {
    assert(typeof value === "string", "url is not a string");
    var url = parseUrl__default['default'](value);
    assert(!!url.hostname, "invalid url: '" + value + "', unable to parse hostname");
    return url;
}
function assertValidEnvFilters(value) {
    assert(!!value && typeof value === "object", "Provided filters must be an object");
    var filters = value;
    if (filters.env !== undefined) {
        assert(filters.env instanceof Array, 'filters.env must be an array');
        assert(filters.env.every(function (env) { return VALID_ENV_FILTERS.indexOf(env) >= 0; }), "'" + filters.env + "' - filters.env must be an array containing only: " + VALID_ENV_FILTERS.join(','));
    }
    if (filters.status !== undefined) {
        assert(filters.status instanceof Array, 'filters.status must be an array');
        assert(filters.status.every(function (status) { return VALID_ENV_STATUSES.indexOf(status) >= 0; }), "'" + filters.status + "' - filters.status must be an array containing only: " + VALID_ENV_STATUSES.join(','));
    }
}

var _environments = [
	{
		name: "prod",
		region: "us-east-1",
		status: "stable",
		publicDomainName: "mypurecloud.com",
		publicDomainAliases: [
		]
	},
	{
		name: "prod-euc1",
		region: "eu-central-1",
		status: "stable",
		publicDomainName: "mypurecloud.de",
		publicDomainAliases: [
		]
	},
	{
		name: "prod-euw1",
		region: "eu-west-1",
		status: "stable",
		publicDomainName: "mypurecloud.ie",
		publicDomainAliases: [
		]
	},
	{
		name: "prod-apne1",
		region: "ap-northeast-1",
		status: "stable",
		publicDomainName: "mypurecloud.jp",
		publicDomainAliases: [
		]
	},
	{
		name: "prod-apse2",
		region: "ap-southeast-2",
		status: "stable",
		publicDomainName: "mypurecloud.com.au",
		publicDomainAliases: [
		]
	},
	{
		name: "prod-usw2",
		region: "us-west-2",
		status: "stable",
		publicDomainName: "usw2.pure.cloud",
		publicDomainAliases: [
		]
	},
	{
		name: "prod-cac1",
		region: "ca-central-1",
		status: "stable",
		publicDomainName: "cac1.pure.cloud",
		publicDomainAliases: [
		]
	},
	{
		name: "prod-euw2",
		region: "eu-west-2",
		status: "stable",
		publicDomainName: "euw2.pure.cloud",
		publicDomainAliases: [
		]
	},
	{
		name: "prod-apne2",
		region: "ap-northeast-2",
		status: "stable",
		publicDomainName: "apne2.pure.cloud",
		publicDomainAliases: [
		]
	},
	{
		name: "prod-aps1",
		region: "ap-south-1",
		status: "beta",
		publicDomainName: "aps1.pure.cloud",
		publicDomainAliases: [
		]
	}
];

var environments = _environments;
var DEFAULT_LOCAL_HOSTNAMES = ["localhost", "127.0.0.1"];
var STABLE_PROD_FILTERS = { env: ["prod"], status: ["stable"] };
var NO_FILTERS = {};
var endsWith = function (s1, s2) {
    return s1.slice(s1.length - s2.length) === s2;
};
var matchesHostname = function (hostname) { return function (domain) {
    return endsWith(hostname, domain);
}; };
var parseEnvFromName = function (name) {
    var env = name.split("-")[0];
    return env;
};
/**
 * Retrieves the list of Genesys Cloud environment/region deployments.
 * Defaults to only returning stable prod deployments.
 */
var getEnvironments = function (filters) {
    if (filters === void 0) { filters = STABLE_PROD_FILTERS; }
    assertValidEnvFilters(filters);
    var env = filters.env, status = filters.status;
    return environments
        .map(function (data) { return (__assign(__assign({}, data), { env: parseEnvFromName(data.name) })); })
        .filter(function (data) { return env === undefined || env.indexOf(data.env) >= 0; })
        .filter(function (data) { return status === undefined || status.indexOf(data.status) >= 0; });
};
/**
 * Whether or not the given url is a known Genesys Cloud deployment.
 * - throws an error if passed an invalid url
 * - returns false for localhost
 */
var isKnown = function (url, filters) { return !!parse(url, filters); };
/**
 * Retrieve the Genesys Cloud `Environment` for a given url
 * - throws an error if passed an invalid url
 * - returns undefined if no match is found
 */
var parse = function (url, filters) {
    var hostname = parseValidUrl(url).hostname;
    return getEnvironments(filters).find(function (_a) {
        var publicDomainName = _a.publicDomainName, publicDomainAliases = _a.publicDomainAliases;
        var domains = __spreadArrays([publicDomainName], publicDomainAliases).filter(function (d) { return !!d; });
        return domains.some(matchesHostname(hostname));
    });
};
/**
 * Retrieve the current Genesys Cloud runtime environment for the given url.
 * This method attempts to parse the hostname directly (uses `parse` under the hood).
 *
 * By default, this method will attempt to search across all available environments (no filtering).
 */
var parseDeployedRuntime = function (url, filters) {
    if (url === void 0) { url = window.location.href; }
    if (filters === void 0) { filters = NO_FILTERS; }
    assertValidEnvFilters(filters);
    var hostname = parseValidUrl(url).hostname;
    var parsedEnv = parse(url, filters);
    if (!parsedEnv)
        return;
    return __assign(__assign({}, parsedEnv), { local: false, currentDomainName: __spreadArrays([
            parsedEnv.publicDomainName
        ], parsedEnv.publicDomainAliases).filter(function (d) { return !!d; }).find(matchesHostname(hostname)) });
};
/**
 * When the hostname matches a valid local hostname, either by matching our defaults or your custom list
 * passed in the options, this method will attempt to match the first path param by name to an environment.
 * The list of environment names can be retrieved by calling `getEnvironments` and can be found under the
 * `name` key.
 *
 * By default, this method will attempt to search across all available environments (no filtering).
 *
 * Note: `currentDomainName` will be equal to `publicDomainName` when using this method.
 * Example: https://localhost:3000/prod => us-east-1 prod environment & runtime details
 */
var parseRuntimeFromLocalPath = function (localHostnames) {
    if (localHostnames === void 0) { localHostnames = DEFAULT_LOCAL_HOSTNAMES; }
    return function (url, filters) {
        if (url === void 0) { url = window.location.href; }
        if (filters === void 0) { filters = NO_FILTERS; }
        assertValidEnvFilters(filters);
        assertValidStringArray(localHostnames, 'localHostnames');
        var _a = parseValidUrl(url), hostname = _a.hostname, pathname = _a.pathname;
        if (localHostnames.some(matchesHostname(hostname))) {
            var _b = pathname.split("/"), envName_1 = _b[1];
            var localEnv = getEnvironments(filters).find(function (e) { return e.name === envName_1; });
            if (!localEnv)
                return;
            return __assign(__assign({}, localEnv), { local: true, currentDomainName: localEnv.publicDomainName });
        }
    };
};
/**
 * This is the default and recommended `RuntimeParser` implementation that is composed of the
 * `parseDeployedRuntime` and `parseRuntimeFromLocalPath` parsers. You might opt to compose the
 * `parseDeployedRuntime` with your own `RuntimeParser` as an alternative to parseRuntimeFromLocalPath.
 * You may also opt to use "parse" and `getEnvironments` together to create your own parsing strategy.
 */
var parseRuntime = function (url, filters) {
    if (url === void 0) { url = window.location.href; }
    if (filters === void 0) { filters = NO_FILTERS; }
    return parseRuntimeFromLocalPath()(url, filters) || parseDeployedRuntime(url, filters);
};

exports.getEnvironments = getEnvironments;
exports.isKnown = isKnown;
exports.parse = parse;
exports.parseDeployedRuntime = parseDeployedRuntime;
exports.parseRuntime = parseRuntime;
exports.parseRuntimeFromLocalPath = parseRuntimeFromLocalPath;
